// SerialQueue runs tasks one at a time, in the order run() was called.
// A rejected task settles its own promise and leaves the chain able to
// start the next task. idle() resolves when every task queued so far has
// settled, including one that rejected.
export class SerialQueue {
    #chain: Promise<void> = Promise.resolve();

    run<T>(task: () => Promise<T> | T): Promise<T> {
        const run = this.#chain.then(task, task);
        this.#chain = run.then(() => undefined, () => undefined);
        return run;
    }

    idle(): Promise<void> {
        return this.#chain.then(() => undefined);
    }
}
